import React from 'react'
import SyncButton from '../../ui/sync-button'
import { regHolderBasePath } from '../../reg-holder'

// doNotShow is a temporary measure, as we are removing the button from display for now
const EnrolmentsSyncButtons = ({ regHolder, start_date, onComplete, doNotShow = true }) => (
  doNotShow ?
    null :
    <SyncButton
      key={`payments-${start_date}`}
      steps={[
        {
          syncPath: `${regHolderBasePath(regHolder)}/sync-gov-session-reports-for-week?week=${start_date}`,
          text: 'Pulling records from government'
        },
        {
          syncPath: `${regHolderBasePath(regHolder)}/session-summaries/calculate?week=${start_date}`
        },
      ]}
      onComplete={onComplete}
    />
)

export default EnrolmentsSyncButtons



// WEBPACK FOOTER //
// ./src/payments/views/sync-buttons.jsx